import { ErrorMsg } from 'commonTypes'
import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDataContext } from 'context/DataContext'
import { Routes } from 'common/routeConfig'
import DriversCard from '../report/molecularBiomarker/MolecularBiomarkersCard'
import ReportMenuCommonLayout from '../../components/reportMenuCommonLayout/ReportMenuCommonLayout'

type DriversProps = {
    isMenuOpen: boolean
}

const Drivers: React.FC<DriversProps> = ({ isMenuOpen }) => {
    const { t } = useTranslation('molecularBiomarkers')
    const [error] = useState(false)
    const [errorMsg] = useState<ErrorMsg>()

    const navigate = useNavigate()
    const listViewBoxRef = useRef<HTMLSpanElement>(null)
    const containerRef = useRef<HTMLDivElement>(null)
    const { drivers } = useDataContext()

    useEffect(() => {
        if (!drivers) {
            navigate(Routes.BASE)
            window.location.reload()
        }
    }, [navigate, drivers])

    return (
        <ReportMenuCommonLayout
            isLoading={false}
            isMenuOpen={isMenuOpen}
            title={t('listTitle')}
            targetUrl="drivers"
            error={error}
            errorMsg={errorMsg}
            scrollRef={listViewBoxRef}
            ref={containerRef}
            hasFilters={true}
            subtitle={''}
            tableTitle={''}
        >
            <DriversCard driverData={drivers} isReportPage />{' '}
        </ReportMenuCommonLayout>
    )
}

export default Drivers
